import axios from "axios";

let MASTER_API_URL;
if (process.env.REACT_APP_NODE_ENV === "local") {
    MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
} else {
    MASTER_API_URL = process.env.REACT_APP_API_URL + "masters";
}

export const getAllDropdown = async () => {
    const response = await axios
        .get(MASTER_API_URL + "/dropdownvalue/get")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            return { message: "Unable to find request", status: false };
        });
    return response.data;
}

export const getDropdownRecordsByFieldname = async (data) => {
    const response = await axios
        .post(MASTER_API_URL + "/dropdownvalue/getbyfieldname", data)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            return { data: { message: "Unable to find request", status: false } };
        });
    return response.data;
}

export const updateDropdownValue = async (data) => {
    const response = await axios
        .post(MASTER_API_URL + "/dropdownvalue/update", data)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            return { data: error.response?.data || { message: "Unable to find request", status: false } };
        });
    return response.data;
};

export const addDropdownValue = async (data) => {
    const response = await axios
        .post(MASTER_API_URL + "/dropdownvalue", data)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            return { data: error.response?.data || { message: "Unable to find request", status: false } };
        });
    return response.data;
};

export const deleteDropdownValue = async (data) => {
    const response = await axios
        .post(MASTER_API_URL + "/dropdownvalue/delete", data)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            return { data: { message: "Unable to find request", status: false } };
        });
    return response.data;
};